export default __webpack_public_path__ + "media/images/search_icon01-dfb01c156506bfeea1940f545b70a38f.svg";